import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { TypeChecker } from '@attain-apps/type-guards'

import * as state from '../../../../../../../state'

import * as recordFilters from './filters'

@ngCore.Component({
  imports: [
    ds.table.Component,
    ds.layout.page.Component,
    recordFilters.Component,
  ],
  selector: 'atn-space-lite-records-list',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  // TODO: Possibly make an input for records collection that will allow reuse
  // between full and lite space
  /** @see {@link state.space.lite.records.Collection} */
  public readonly recordsEc = ngCore.inject(state.space.lite.records.Collection)

  /** Canonical table input for the lite Space records list. */
  public readonly tableConfig = {
    collection: this.recordsEc,
    view: {
      pagination: true,
      showColumnSettings: false,
      title: 'Records List',
    },
  } satisfies ds.table.ec.Config.Input<state.space.lite.records.TypeParams>

  /** Whether records Current List filters are applied. */
  public readonly hasAppliedParamsSg = ngCore.computed(
    (
      filters = this.recordsEc.plugins.currentListPlugin.appliedParams.selectors.filters.asSignal(),
    ) => Object.values(filters ?? {}).some(TypeChecker.isNotNullish.raw),
  )

  /** Starts editing the records Current List parameters. */
  public filtersClickHandler(): void {
    this.recordsEc.plugins.currentListPlugin.feature.actions.startEditingParams
      .from('Space.Lite.RecordsList.Filters.Icon.Clicked')
      .dispatch()
  }
}
